import React from 'react';
import { useTranslation } from 'react-i18next';

const ProblemCard = ({ icon, problem, description }) => (
  <div className="tk-card text-center">
    <div className="flex justify-center mb-4">
      <div className="text-4xl">{icon}</div>
    </div>
    <h3 className="text-xl font-semibold text-white mb-4">{problem}</h3>
    <p className="text-gray-300 leading-relaxed italic">"{description}"</p>
  </div>
);

const Testimonials = () => {
  const { t } = useTranslation();

  const problems = [
    {
      icon: '😤',
      problem: t('testimonials.problem1.title'),
      description: t('testimonials.problem1.description')
    },
    {
      icon: '🏃‍♂️',
      problem: t('testimonials.problem2.title'),
      description: t('testimonials.problem2.description')
    },
    {
      icon: '🗓️',
      problem: t('testimonials.problem3.title'),
      description: t('testimonials.problem3.description')
    },
    {
      icon: '🏟️',
      problem: t('testimonials.problem4.title'),
      description: t('testimonials.problem4.description')
    },
    {
      icon: '⏰',
      problem: t('testimonials.problem5.title'),
      description: t('testimonials.problem5.description')
    },
    {
      icon: '🌍',
      problem: t('testimonials.problem6.title'),
      description: t('testimonials.problem6.description')
    }
  ];

  return (
    <section id="testimonials" className="bg-gray-900 py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            {t('testimonials.title')}
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            {t('testimonials.subtitle')}
            <span className="text-brand font-semibold">{t('testimonials.subtitleHighlight')}</span>
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {problems.map((problem, index) => (
            <ProblemCard key={index} {...problem} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;